<template>
    <van-popup v-model:show="show" position="center" :style="{
        width: '90%',
        // minHeight: '40%',
        borderRadius: '15px',
        background: '#2d323d',
        zIndex: '10001',
        padding: '20px'
    }">

        <van-row :gutter="10" class="container">
            <van-col :span="24">
                <div class="middle_title">{{ $t('profile.toLogout') }}</div>

            </van-col>
            <van-col :span="24">
                <div class="tip">
                    <!-- Tem certeza de que deseja sair? -->
                    {{ $t('profile.sureToLogout') }}
                </div>
            </van-col>
            <div class="button-row">
                <van-col :span="12" class="cancel_btn" @click="close">{{ $t('profile.cancel') }}</van-col>
                <van-col :span="12" class="loagout_btn" @click="logOut">{{ $t('profile.toLogout') }}</van-col>
            </div>

        </van-row>
    </van-popup>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { ref } from 'vue'
const show = ref(false)
const userStore = useUserStore()
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}
const logOut = () => {
    userStore.signOut()
    sessionStorage.setItem('openPromotionPopup', '');
}
defineExpose({
    open,
})

</script>
<style scoped>
.container :deep(.van-col) {
    display: flex;
    justify-content: center;
    align-items: center;
}

.title {
    padding: 10px 25px;
    font-size: 14px;
    background-color: #ffffff0a;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
    height: 45px;
}


.van-overlay {
    background-color: #00000047;
    backdrop-filter: blur(20px) !important;
    z-index: 3000 !important;
}


.content {
    padding: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 10001;
}

.content img {
    width: 100px;
}

.middle_title {
    color: #fff;
    font-size: 20px;
    padding: 15px;
    font-weight: 700;
}

.button-row {
    display: flex;
    gap: 10px;
    width: 100%;
    margin-top: 10px;
}

.tip {
    color: #ffffffa6;
    font-size: 13px;
    padding: 20px 5px;
    text-align: center;
}

.cancel_btn {
    background: linear-gradient(0deg, rgba(10, 114, 210, 1) 0%, rgba(47, 157, 242, 1) 100%);
    border-radius: 5px;
    color: #fff;
    font-size: 15px;
    padding: 20px;
    border-radius: 10px;
    padding-left: 0px;
}

.loagout_btn {

    color: #fff;
    font-size: 15px;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #0167ca;
    padding-right: 0px;
}
</style>